import { api } from "./client";

export interface AlertSettings {
  email_alerts_enabled: boolean;
  telegram_alerts_enabled: boolean;
  telegram_chat_id?: string;
  whatsapp_alerts_enabled: boolean;
  whatsapp_number?: string;
}

export async function fetchAlertSettings(): Promise<AlertSettings> {
  const res = await api.get("/alerts/settings");
  return res.data;
}

export async function updateAlertSettings(settings: AlertSettings): Promise<{ message: string }> {
  const res = await api.put("/alerts/settings", settings);
  return res.data;
}

export async function testEmailAlert(email?: string): Promise<{ message: string }> {
  const res = await api.post("/alerts/test-email", { email });
  return res.data;
}

export async function testTelegramAlert(chatId: string): Promise<{ message:string }> {
  const res = await api.post("/alerts/test-telegram", { chat_id: chatId });
  return res.data;
}

export async function testWhatsappAlert(number: string): Promise<{ message: string }> {
  const res = await api.post("/alerts/test-whatsapp", { number });
  return res.data;
}
